export const CenterAlignSvg = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.5851 1.30176H1.41286C0.631749 1.30176 0 1.93351 0 2.71461C0 3.49572 0.631749 4.12747 1.41286 4.12747H18.5871C19.3683 4.12747 20 3.49572 20 2.71461C20 1.93351 19.3662 1.30176 18.5851 1.30176Z"
        fill="currentColor"
      />
      <path
        d="M18.5851 11.0161H1.41286C0.631749 11.0161 0 11.6478 0 12.429C0 13.2101 0.631749 13.8418 1.41286 13.8418H18.5871C19.3683 13.8418 20 13.2101 20 12.429C20 11.6478 19.3662 11.0161 18.5851 11.0161Z"
        fill="currentColor"
      />
      <path
        d="M16.2297 8.98367C17.0108 8.98367 17.6426 8.35192 17.6426 7.57082C17.6426 6.78971 17.0108 6.15796 16.2297 6.15796H3.77031C2.9892 6.15796 2.35745 6.78971 2.35745 7.57082C2.35745 8.35192 2.9892 8.98367 3.77031 8.98367H16.2297Z"
        fill="currentColor"
      />
      <path
        d="M13.7754 18.698C14.5565 18.698 15.1882 18.0663 15.1882 17.2852C15.1882 16.504 14.5565 15.8723 13.7754 15.8723H6.22263C5.44152 15.8723 4.80977 16.504 4.80977 17.2852C4.80977 18.0663 5.44152 18.698 6.22263 18.698H13.7754Z"
        fill="currentColor"
      />
    </svg>
  );
};
